import { inject } from '@angular/core';
import { SavePartnerService } from '@domains/partner/save-partner-button/save-partner.service';
import { Actions, createEffect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  deleteBankingProduct,
  deleteBankingProductFailure,
  deleteBankingProductSuccess,
  getBankingProductList,
  setBankingProductList,
} from '@stores/banking-products/banking-product.actions';
import { partnerId } from '@stores/partner-revision/partner-revision.selectors';
import { BankingProductsWebservice } from '@webservices/banking-products/banking-products.webservices';
import { catchError, filter, map, of, switchMap } from 'rxjs';

export const loadAllBankingProductsEffect = createEffect(
  (actions$ = inject(Actions), bankingProductsWebService = inject(BankingProductsWebservice), store = inject(Store)) =>
    actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => store.select(partnerId)),
      filter((partnerId): partnerId is string => !!partnerId),
      switchMap((partnerId) => bankingProductsWebService.getAll(partnerId)),
      map((bankingProducts) => setBankingProductList({ bankingProducts }))
    ),
  { functional: true }
);

export const getAllBankingProductsEffect = createEffect(
  (actions$ = inject(Actions), bankingProductsWebService = inject(BankingProductsWebservice), store = inject(Store)) =>
    actions$.pipe(
      ofType(getBankingProductList),
      switchMap(() => store.select(partnerId)),
      filter((partnerId): partnerId is string => !!partnerId),
      switchMap((partnerId) => bankingProductsWebService.getAll(partnerId)),
      map((bankingProducts) => setBankingProductList({ bankingProducts }))
    ),
  { functional: true }
);

export const deleteBankingProductEffect = createEffect(
  (
    actions$ = inject(Actions),
    bankingProductsWebService = inject(BankingProductsWebservice),
    savePartnerService = inject(SavePartnerService)
  ) =>
    actions$.pipe(
      ofType(deleteBankingProduct),
      switchMap(({ bankingProductId }) =>
        bankingProductsWebService.delete(bankingProductId).pipe(
          map(() => {
            savePartnerService.success('Produit financier supprimé');
            return deleteBankingProductSuccess({ bankingProductId });
          }),
          catchError((error) => {
            let errorMessage = error?.error?.message || error?.message || 'Erreur lors de la suppression';
            if (error.status === 422) {
              errorMessage =
                'Ce produit financier ne peut pas être supprimé car il est utilisé dans un ou plusieurs plans.';
            }
            savePartnerService.failed(errorMessage);
            return of(deleteBankingProductFailure({ error: errorMessage, bankingProductId }));
          })
        )
      )
    ),
  { functional: true }
);
